import Logo from '@/components/logo';

export default function AuthLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <div className='flex min-h-screen items-center justify-center'>
      <div className='flex w-full flex-col space-y-8 px-8 md:px-0 lg:w-1/3 2xl:w-1/4'>
        <Logo />
        <div>{children}</div>
      </div>
    </div>
  );
}
